import { useSelector } from "react-redux";
import {
  getCalculatedHotspotCoordinates,
  getImage,
  getTemplate,
  getThumbnailFrameIndex,
} from "../../redux/selectors";
import { useEffect, useRef } from "react";
import Hotspot from "../Hotspot/Hotspot";
import { thumbnailScale } from "../../config";

export function HotspotThumbnail({
  frame: inputFrame,
  hotspotIndex,
  size = { dw: 60, dh: 60 },
  scale = thumbnailScale,
}) {
  const thumbnailFrame =
    useSelector((state) => getThumbnailFrameIndex(state, { hotspotIndex })) ??
    undefined;
  const frame = inputFrame ?? thumbnailFrame;
  const image = useSelector((state) => getImage(state, { frame }));
  const { x, y } =
    useSelector((state) =>
      getCalculatedHotspotCoordinates(state, { hotspotIndex, frame })
    ) ?? {};
  const canvasRef = useRef();
  const { dw, dh } = size;

  function updateCanvas() {
    if (!image?.complete) {
      return;
    }
    const canvas = canvasRef.current;
    if (!canvas) {
      return;
    }
    const w = image.naturalWidth;
    const h = image.naturalHeight;
    const ctx = canvas.getContext("2d");
    ctx.globalCompositeOperation = "copy";
    ctx.drawImage(
      image,
      Math.floor(x * w * 0.01 - (dw * 0.5) / scale),
      Math.floor(y * h * 0.01 - (dh * 0.5) / scale),
      dw / scale,
      dh / scale,
      0,
      0,
      dw,
      dh
    );
  }
  useEffect(updateCanvas, [image, dw, dh, x, y, scale]);
  const template = useSelector((state) => getTemplate(state, { hotspotIndex }));
  return frame === null ? null : (
    <div style={{ position: "relative", width: `${dw}px`, height: `${dh}px` }}>
      <canvas ref={canvasRef} width={dw} height={dh} />
      <Hotspot
        template={template}
        coordinates={{ x: 50, y: 50 }}
        className="disableAnimation"
        style={{
          pointerEvents: "none",
          transform: `scale(${scale}) 
           translate(-${scale * 50}%, -${scale * 50}%)`,
        }}
      />
    </div>
  );
}

export default HotspotThumbnail;
